import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'numberToArray',
})
export class NumberToArrayPipe implements PipeTransform {
    transform(value: number): number[] {
        const array: number[] = [];
        for (let i = 1; i <= value; i++) {
            array.push(i);
        }
        return array;
    }
}
